import * as React from 'react'
import { useLocation, Link } from 'react-router-dom'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import Stack from '@mui/material/Stack'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import PersonIcon from '@mui/icons-material/Person'
import ApartmentIcon from '@mui/icons-material/Apartment'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import AssignmentIcon from '@mui/icons-material/Assignment'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import TableRowsIcon from '@mui/icons-material/TableRows'
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf'

const mainListItems = [
    { text: 'Tableau de bord', icon: <HomeRoundedIcon />, href: '/' },
    {
        text: 'Base de données',
        icon: <TableRowsIcon />,
        // Group these items under "Base de données"
        subItems: [
            { text: 'Biens', icon: <ApartmentIcon />, href: '/properties' },
            { text: 'Contrats de location', icon: <AssignmentIcon />, href: '/leases' },
            { text: 'DPE', icon: <EnergySavingsLeafIcon />, href: '/dpe' },
            { text: 'Entreprises', icon: <Diversity3Icon />, href: '/companies' },
            { text: 'Paiements', icon: <RequestQuoteIcon />, href: '/payments' },
            { text: 'Personnes', icon: <PersonIcon />, href: '/people' },
        ],
    },
    { text: 'Fichiers', icon: <FolderOpenIcon />, href: '/files' },
    { text: 'Déclarations', icon: <AccountBalanceIcon />, href: '/taxes' },
]

export default function MenuContent() {
    const location = useLocation()
    const [openSubmenu, setOpenSubmenu] = React.useState(null)

    // When the user hovers over the grouped menu area, open it.
    const handleMouseEnter = (text) => {
        setOpenSubmenu(text)
    }
    // When the mouse leaves, collapse the submenu.
    const handleMouseLeave = () => {
        setOpenSubmenu(null)
    }

    return (
        <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
            <List dense>
                {mainListItems.map((item, index) => {
                    if (item.subItems) {
                        return (
                            <React.Fragment key={index}>
                                {/* Wrap the group in a container that listens for mouse events */}
                                <div
                                    onMouseEnter={() => handleMouseEnter(item.text)}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton>
                                            <ListItemIcon>{item.icon}</ListItemIcon>
                                            <ListItemText primary={item.text} />
                                            {openSubmenu === item.text ? (
                                                <ExpandLessIcon />
                                            ) : (
                                                <ExpandMoreIcon />
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                    <Collapse
                                        in={openSubmenu === item.text}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            {item.subItems.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    disablePadding
                                                    sx={{ display: 'block' }}
                                                >
                                                    <ListItemButton
                                                        component={Link}
                                                        to={subItem.href}
                                                        selected={location.pathname === subItem.href}
                                                        sx={{ pl: 4 }} // indent nested items
                                                    >
                                                        <ListItemIcon>{subItem.icon}</ListItemIcon>
                                                        <ListItemText primary={subItem.text} />
                                                    </ListItemButton>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>
                                </div>
                            </React.Fragment>
                        )
                    }
                    return (
                        <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                component={Link}
                                to={item.href}
                                selected={location.pathname === item.href}
                            >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    )
                })}
            </List>

        </Stack>
    )
}
